'use strict';

/**
 * Validates form fields in real-time as users interact with them
 * @param {jQuery} formElement - The jQuery form element
 */
module.exports = function (formElement) {
    if (!formElement || !formElement.length) return;

    // Get all required input fields in the form
    const inputFields = $('[required], .required', formElement);

    // Add blur event listener to each input field
    inputFields.on('blur', function () {
        const currentField = $(this);
        const fieldValue = currentField.val().trim();

        // Check if field is empty
        const isEmpty = fieldValue === '';

        // Get error message element (assuming it has a specific class or data attribute)
        const errorElement = currentField.parent().find('.invalid-feedback');

        // Apply validation styling
        if (isEmpty) {
            currentField.addClass('is-invalid');
            if (errorElement.length) {
                errorElement.text(currentField.data('missing-error') || window.SitePreferences ? window.SitePreferences.FIELD_IS_REQUIRED : 'Field is required');
            }
        }
    });
};
